import React, { useEffect, useMemo, useState } from "react";
import { store } from "../../App";
import KpiService from "../../Services/KpiService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "./PerformanceDashboard.css";
import { Button, Col, Container, Row, Nav, Alert, Accordion, Table, Tab } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { RiFileExcel2Line } from "react-icons/ri";
import { AiOutlineSearch } from "react-icons/ai";
import { GrDocumentPdf } from "react-icons/gr";
import Menubar from "../Menubar";

const ScoreCards = () => {

    const [cardData, setCardData] = useState({});
    const [cardData1, setCardData1] = useState([]);
    const [indicatorDetails, setIndicatorDetails] = useState([]);
    const [periodicityData, setPeriodicityData] = useState([]);
    const [indicatorData, setIndicatorData] = useState([])
    const [indicatorData1, setIndicatorData1] = useState([])
    const [sectorData, setSectorData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [showModal1, setShowModal1] = useState(false);
    const [searchText1, setSearchText1] = useState("");
    const [searchText3, setSearchText3] = useState("");
    const [DeptWise, setDeptWise] = useState([]);

    const username = localStorage.getItem("username");
    const role_cat_id = localStorage.getItem("catid");
    const districtid = localStorage.getItem("districtid");
    let mandalid = localStorage.getItem("mandalid");


    useEffect(() => {
        fetchAllData();
    }, [districtid]);

    const fetchAllData = async () => {

        try {



            store.dispatch({ type: "SHOW_SPINNER" });

            // CARD API
            const cardRes = await KpiService.criticalDashboardScoreCard({
                userId: username,
                type: (role_cat_id === "119" || role_cat_id === "113") ? "dist" : "mandal",
                year: "2025-26",
                districtId: districtid ?? "0",
                "mandalId": mandalid ?? "0"
            });

            if (cardRes?.data?.dataList?.length > 0) {
                setCardData(cardRes.data.dataList[0]);
            } else {
                setCardData({});
            }

            //mandal table 

            // CARD API
            const mandalres = await KpiService.criticalDashboardScoreCard({
                userId: username,
                type: "mandal",
                year: "2025-26",
                districtId: districtid ?? "0",
                "mandalId": mandalid ?? "0"
            });

            if (mandalres?.data?.dataList?.length > 0) {
                setCardData1(mandalres.data.dataList);
            } else {
                setCardData1({});
            }


            // INDICATORS API
            const indicatorRes = await KpiService.criticalDashboardIndicators({
                "userId": username,
                "type": "dist",
                "typetwo": "distPreiodicity",
                "typethree": "distIndicator",
                "districtId": districtid ?? "0",
                "mandalId": mandalid ?? "0"
            });

            if (indicatorRes?.data) {
                setIndicatorDetails(indicatorRes.data.indicatorDetailsData || []);
                setPeriodicityData(indicatorRes.data.periodicityData || []);
                setIndicatorData(indicatorRes.data.indicatorData || []);
            }


            // DEPT WISE API
            const deptWiseRes = await KpiService.criticalDashboardDeptWise({
                userId: username,
                type: "depts",
                year: "2025-26",
                districtId: districtid ?? "0",
                mandalId: mandalid ?? "0"
            });

            if (deptWiseRes?.data?.dataList?.length > 0) {
                setDeptWise(deptWiseRes.data.dataList);
            } else {
                setDeptWise([]);
            }

        } catch (error) {
            console.log("Error fetching data:", error);
        } finally {
            store.dispatch({ type: "HIDE_SPINNER" });
        }
    };

    const monthMap = {
        "1": "January",
        "2": "February",
        "3": "March",
        "4": "April",
        "5": "May",
        "6": "June",
        "7": "July",
        "8": "August",
        "9": "September",
        "10": "October",
        "11": "November",
        "12": "December"
    };

    const handleDistrictClick = async (item) => {
        try {
            store.dispatch({ type: "SHOW_SPINNER" });
            const indicatorRes = await KpiService.criticalDashboardIndicators({
                userId: username,
                type: "dist",
                typetwo: "distPreiodicity",
                typethree: "distIndicator",
                districtId: districtid ?? "0",
                mandalId: item.mandal_id
            });

            if (indicatorRes?.data) { setIndicatorData1(indicatorRes.data.indicatorData || []); } else { setIndicatorData1([]); }
            setShowModal(true);
        } catch (error) {
            console.log("Error fetching data:", error); setIndicatorData1([]);
        } finally { store.dispatch({ type: "HIDE_SPINNER" }); }
    };

    const handleSectorctClick = async (item) => {
        try {
            store.dispatch({ type: "SHOW_SPINNER" });

            const indicatorRes = await KpiService.criticalDashboardBroadSectorWise({
                userId: username,
                type: "sectors",
                year: "2025-26",
                districtId: districtid ?? "0",
                mandalId: mandalid ?? "0",
                indBroadSectorId: item?.ind_broad_sector_id
            });

            console.log("Full Response:", indicatorRes);
            console.log("Data List:", indicatorRes?.data?.dataList);

            if (indicatorRes?.data?.dataList?.length > 0) {
                setSectorData(indicatorRes.data.dataList);
            } else {
                setSectorData([]);
            }

            setShowModal1(true);

        } catch (error) {
            console.log("Error fetching data:", error);
            setSectorData([]);
        } finally {
            store.dispatch({ type: "HIDE_SPINNER" });
        }
    };

    const filteredIndicatorData = indicatorData1.filter((item) => {
        const search = searchText.trim().toLowerCase();
        return (
            item.district_name?.toLowerCase().includes(search) ||
            item.mandal_name?.toLowerCase().includes(search) ||
            item.sectors?.toLowerCase().includes(search) ||
            String(item.noofindicators)?.toLowerCase().includes(search) ||
            String(item.averagescore)?.toLowerCase().includes(search) ||
            item.grade?.toLowerCase().includes(search)
        );
    });

    const filteredData = useMemo(() => {
        const search = searchText1.trim().toLowerCase();
        return sectorData.filter((item) => {
            return (
                item.district_name?.toLowerCase().includes(search) ||
                item.mandal_name?.toLowerCase().includes(search) ||
                item.ind_broad_sector_name?.toLowerCase().includes(search) ||
                String(item.noofindicators)?.toLowerCase().includes(search) ||
                String(item.averagescore)?.toLowerCase().includes(search) ||
                item.grade?.toLowerCase().includes(search)
            );
        });
    }, [sectorData, searchText1]);


    const filteredDeptData = DeptWise.filter((item) => {
        const search = searchText3.trim().toLowerCase();

        return (
            item.secretariat_name?.toLowerCase().includes(search) ||
            item.dept_name?.toLowerCase().includes(search) ||
            String(item.noofindicators)?.toLowerCase().includes(search) ||
            String(item.averagescore)?.toLowerCase().includes(search) ||
            item.grade?.toLowerCase().includes(search)
        );
    });

    const exportToExcel = (tableid, name) => {
        const table = document.getElementById(tableid);
        if (!table) return;
        const safeName = name.replace(/[:\\/?*\[\]]/g, ""); // remove invalid chars
        const sheetName = safeName.substring(0, 31); // MAX 31 chars only
        const workbook = XLSX.utils.table_to_book(table);
        const firstSheetName = workbook.SheetNames[0];
        workbook.SheetNames[0] = sheetName;
        workbook.Sheets[sheetName] = workbook.Sheets[firstSheetName];
        delete workbook.Sheets[firstSheetName];

        XLSX.writeFile(workbook, `${safeName}.xlsx`);
    };

    const exportToPDF = (tableid, name) => {
        const doc = new jsPDF();

        autoTable(doc, {
            html: `#${tableid}`,
            startY: 20,
        });

        doc.save(name + ".pdf");
    };

    const stickyStyle = {
        position: "sticky",
        top: 0,
        background: "#4f7f5f",
        color: "#fff",
        zIndex: 2
    };

    return (<>
        <Menubar />
        <div
            style={{
                background: "#f4f6f9",
                padding: "25px 0 60px 0",
                minHeight: "70vh",
                display: "flex",
                justifyContent: "center"
            }}
        >
            <div
                style={{
                    background: "white",
                    padding: "25px",
                    borderRadius: "20px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    display: "flex",
                    gap: "30px",
                    width: "1950px",
                    maxWidth: "2000px",
                    margin: "0 auto",
                    alignItems: "flex-start"
                }}
            >

                {/* LEFT CARD */}
                <div
                    style={{
                        flex: "0 0 750px",
                        background: "#f7f7f7",
                        borderRadius: "18px",
                        padding: "18px",
                        position: "relative"
                    }}
                >
                    {/* HEADER CARD */}
                    <div
                        style={{
                            background: cardData?.color_code,
                            padding: "25px",
                            borderRadius: "20px",
                            color: "#000",
                            position: "relative"
                        }}
                    >
                        <h2 style={{ margin: 0, fontSize: "22px", fontWeight: "600" }}>
                            {(role_cat_id === "113" || role_cat_id === "119")
                                ? cardData?.district_name
                                : `${cardData?.district_name}-${cardData?.mandal_name ?? ""}`}
                        </h2>

                        <p style={{ marginTop: "6px", fontSize: "13px" }}>
                            {monthMap[String(cardData?.score_for_month)] || "Month"} Month Score Card
                        </p>
                    </div>

                    {/* GRADE + AVERAGE SCORE (TOP RIGHT) */}
                    <div
                        style={{
                            position: "absolute",
                            right: "10px",   // 🔥 move inside properly
                            top: "10px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px"
                        }}
                    >
                        {/* Grade Circle */}
                        <div
                            style={{
                                width: "60px",
                                height: "60px",
                                borderRadius: "50%",
                                background: "#fff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "20px",
                                fontWeight: "700",
                                border: `3px solid ${cardData?.color_code || ""}`,
                                boxShadow: "0 3px 8px rgba(0,0,0,0.15)"
                            }}
                        >
                            {cardData?.grade || "-"}
                        </div>

                        {/* Average Score */}
                        <div
                            style={{
                                background: cardData?.color_code || "",
                                padding: "6px 16px",
                                fontSize: "20px",
                                fontWeight: "800",
                                borderRadius: "20px",
                                minWidth: "55px",
                                textAlign: "center",
                                boxShadow: "0 3px 8px rgba(0,0,0,0.15)"
                            }}
                        >
                            {cardData?.averagescore || "-"}
                        </div>
                    </div>

                    {/* LEFT SECTOR TABLE */}
                    <div style={{ overflow: "auto", height: "540px", marginTop: "20px" }}>
                        <table
                            bordered
                            hover
                            id="my-table"
                            className="custom-table table-striped table table-bordered"
                        >
                            <thead>
                                <tr>
                                    <th style={{ position: "sticky", top: 0, background: "#4f7f5f", color: "#fff", zIndex: 2 }}>
                                        Sectors
                                    </th>

                                    {(role_cat_id === "113" || role_cat_id === "119") && (
                                        <th style={{ position: "sticky", top: 0, background: "#4f7f5f", color: "#fff", zIndex: 2 }}>
                                            District
                                        </th>
                                    )}

                                    <th style={{ position: "sticky", top: 0, background: "#4f7f5f", color: "#fff", zIndex: 2 }}>
                                        Mandal
                                    </th>

                                    <th style={{ position: "sticky", top: 0, background: "#4f7f5f", color: "#fff", zIndex: 2 }}>
                                        Score
                                    </th>

                                    <th style={{ position: "sticky", top: 0, background: "#4f7f5f", color: "#fff", zIndex: 2 }}>
                                        Grade
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {indicatorData && indicatorData.length > 0 ? (
                                    indicatorData.map((item, i) => (
                                        <tr key={i}>
                                            <td
                                                style={{
                                                    textAlign: "left",
                                                    cursor: "pointer",
                                                    color: "#2d74c4",
                                                    fontWeight: "600"
                                                }}
                                                onClick={() => handleSectorctClick(item)}
                                            >
                                                {item.sectors}
                                            </td>

                                            {(role_cat_id === "113" || role_cat_id === "119") && (
                                                <td style={{ textAlign: "right" }}>{item.district}</td>
                                            )}

                                            <td style={{ textAlign: "right" }}>{item.mandal}</td>
                                            <td style={{ textAlign: "right" }}>{item.averagescore}</td>
                                            <td style={{ textAlign: "center" }}>{item.grade}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="5"
                                            align="center"
                                            style={{ padding: "15px", color: "red", fontWeight: "500" }}
                                        >
                                            No Details Available
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                            {indicatorData?.length > 0 && (
                                <tfoot>
                                    <tr style={{ backgroundColor: "#4f7f5f", color: "#fff" }}>
                                        <td style={{ textAlign: "center", position: "sticky", bottom: 0 }}>
                                            Total
                                        </td>

                                        {(role_cat_id === "113" || role_cat_id === "119") && (
                                            <td style={{ textAlign: "right", position: "sticky", bottom: 0 }}>
                                                {indicatorData
                                                    ?.reduce((a, v) => a + v.district, 0)
                                                    .toLocaleString("en-IN")}
                                            </td>
                                        )}

                                        <td style={{ textAlign: "right", position: "sticky", bottom: 0 }}>
                                            {indicatorData
                                                ?.reduce((a, v) => a + v.mandal, 0)
                                                .toLocaleString("en-IN")}
                                        </td>

                                        <td style={{ position: "sticky", bottom: 0 }}></td>
                                        <td style={{ position: "sticky", bottom: 0 }}></td>
                                    </tr>
                                </tfoot>
                            )}
                        </table>
                    </div>
                </div>

                {/* RIGHT SIDE TABLES */}

                <div style={{ flex: 1, padding: "10px" }}>
                    {/* Indicators */}
                    <RightTable
                        title="Indicators"

                        role_cat_id={role_cat_id}
                        rows={indicatorDetails && indicatorDetails.length > 0 ? indicatorDetails.map(item => [item.indicators, item.district, item.mandal, item.monitoringdistrictlevel]) : []}
                    />

                    {/* Periodicity */}
                    <RightTable
                        title="Periodicity"
                        showTotal={true}
                        role_cat_id={role_cat_id}
                        rows={periodicityData.map(item => [item.periodic_name, item.district, item.mandal, item.monitoringdistrictlevel])}
                    />

                    <div style={{ overflow: "auto", height: "435px" }}>
                        <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered" >
                            <thead style={{ position: "sticky", top: "0px" }}> <tr> <th>Mandal</th> <th>KPIs</th> <th>Score</th> <th>Grade</th> </tr> </thead>
                            <tbody>
                                {cardData1 && cardData1.length > 0 ? (cardData1.map((item, i) => (<tr key={i}>
                                    <td style={{ textAlign: "left", cursor: "pointer", color: "#2d74c4", fontWeight: "600" }} onClick={() => handleDistrictClick(item)} > {item.mandal_name} </td>
                                    <td style={{ textAlign: "right" }} >{item.noofindicators}</td>
                                    <td style={{ textAlign: "right" }} >{item.averagescore}</td>
                                    <td style={{ textAlign: "center" }} >{item.grade}</td>
                                </tr>))) : (<tr> <td colSpan="4" align="center" style={{ padding: "15px", color: "red", fontWeight: "500" }} > No Details Available </td> </tr>)}
                            </tbody>
                            {cardData1?.length > 0 && <tfoot style={{ position: "sticky", bottom: "0px" }}>
                                <tr style={{ backgroundColor: "#4f7f5f" }}>
                                    <td style={{ textAlign: "center" }}> Total </td>
                                    <td style={{ textAlign: "right" }}>{cardData1?.reduce((a, v) => (a + v.noofindicators), 0).toLocaleString("en-IN")} </td>
                                    <td style={{ textAlign: "right" }}> </td> <td style={{ textAlign: "right" }}> </td> </tr> </tfoot>}
                        </table>
                    </div>

                </div>
            </div>
        </div>

        <div
            style={{
                background: "#f4f6f9",
                padding: "0 0 80px 0",
                display: "flex",
                justifyContent: "center"
            }}
        >
            <div
                style={{
                    background: "white",
                    padding: "25px",
                    borderRadius: "20px",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                    width: "1950px",           // 🔥 smaller card
                    maxWidth: "2000px",     // 🔥 controlled width
                    marginTop: "-10px"
                }}
            >

                {/* SEARCH + TITLE + EXPORT */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "auto 1fr auto",
                        alignItems: "center",
                        marginBottom: "15px"
                    }}
                >
                    {/* LEFT - SEARCH */}
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                            style={{
                                background: "#f1f1f1",
                                padding: "8px 12px",
                                border: "1px solid #ccc",
                                borderRight: "none"
                            }}
                        >
                            <AiOutlineSearch />
                        </div>

                        <input
                            type="text"
                            placeholder="Search"
                            value={searchText3}
                            onChange={(e) => setSearchText3(e.target.value)}
                            style={{
                                padding: "8px",
                                border: "1px solid #ccc",
                                width: "250px"
                            }}
                        />
                    </div>

                    {/* CENTER - TITLE */}
                    <div
                        style={{
                            fontSize: "18px",
                            fontWeight: "600",
                            color: "#2f5e3f",
                            textAlign: "center",
                            justifySelf: "center"   // 🔥 important
                        }}
                    >
                        Critical Indicators KPI list as per Department wise
                    </div>

                    {/* RIGHT - EXPORT BUTTONS */}
                    <div>
                        <Button
                            variant="success"
                            size="sm"
                            onClick={() =>
                                exportToExcel("my-table22", "Critical Indicators KPI list as per Department wise")
                            }
                            style={{ marginRight: "10px" }}
                        >
                            <RiFileExcel2Line />
                        </Button>

                        <Button
                            variant="danger"
                            size="sm"
                            onClick={() =>
                                exportToPDF("my-table22", "Critical Indicators KPI list as per Department wise")
                            }
                        >
                            <GrDocumentPdf />
                        </Button>
                    </div>
                </div>

                {/* TABLE */}
                <div style={{ overflowX: "auto", height: "350px" }}>
                    <table
                        id="my-table22"
                        className="custom-table table table-striped table-bordered"
                        style={{ width: "100%", }}
                    >
                        <thead>
                            <tr style={{ background: "#4f7f5f", color: "white" }}> <th style={stickyStyle}>Sec name</th> <th style={stickyStyle}>Dept Name</th>
                                <th style={stickyStyle}>No.of.indicators</th> <th style={stickyStyle}>Score</th> <th style={stickyStyle}>Grade</th> </tr>
                        </thead>

                        <tbody>
                            {filteredDeptData.length > 0 ? (filteredDeptData.map((item, i) => (<tr key={i}>
                                <td>{item.secretariat_name}</td> <td>{item.dept_name}</td> <td style={{ textAlign: "right" }}>{item.noofindicators}</td>
                                <td style={{ textAlign: "right" }}>{item.averagescore}</td> <td style={{ textAlign: "center" }}>{item.grade}</td>
                            </tr>
                            ))
                            ) : (
                                <tr> <td colSpan="5" style={{ textAlign: "center", color: "red" }}> No Details Available </td> </tr>
                            )}
                        </tbody>
                        {filteredDeptData && filteredDeptData.length > 0 && (
                            <tfoot style={{ position: "sticky", bottom: "0px" }}>
                                <tr style={{ backgroundColor: "#4f7f5f", color: "white", fontWeight: "600" }} >
                                    <td colSpan={2} style={{ textAlign: "center" }}> Total </td>

                                    <td style={{ textAlign: "right" }}> {filteredDeptData.reduce((a, v) => a + v.noofindicators, 0).toLocaleString("en-IN")} </td>

                                    <td colSpan={2}></td> </tr> </tfoot>)} </table>
                </div>

            </div>
        </div>


        <Modal
            show={showModal}
            onHide={() => {
                setSearchText("");
                setShowModal(false);
            }}
            centered
            dialogClassName="custom-modal-width1"
        >

            <Modal.Header
                closeButton
                style={{
                    backgroundColor: "#4f7f5f",
                    color: "white",
                    borderTopLeftRadius: "14px",
                    borderTopRightRadius: "14px"
                }}
            >
                <h4 style={{ margin: 0, fontWeight: "600" }}> Mandal Wise Scores & Grades </h4>
            </Modal.Header>

            <Modal.Body style={{ padding: "20px" }}>
                {indicatorData1 && indicatorData1.length > 0 ? (
                    <>
                        {/* Search + Buttons Row */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "15px",
                                flexWrap: "wrap",
                                gap: "10px"
                            }}
                        >
                            {/* Search */}
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div
                                    style={{
                                        background: "#f1f1f1",
                                        padding: "8px 12px",
                                        border: "1px solid #ccc",
                                        borderRight: "none"
                                    }}
                                >
                                    <AiOutlineSearch />
                                </div>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    value={searchText}
                                    onChange={(e) =>
                                        setSearchText(e.target.value)
                                    }
                                    style={{
                                        padding: "8px",
                                        border: "1px solid #ccc",
                                        outline: "none",
                                        width: "250px"
                                    }}
                                />
                            </div>

                            {/* Buttons */}
                            <div>
                                <Button variant="success" size="sm" style={{ marginRight: "10px" }} onClick={() => exportToExcel("my-table4", "Mandal Wise Data")} > <RiFileExcel2Line /> </Button>
                                <Button variant="danger" size="sm" onClick={() => exportToPDF("my-table4", "Mandal Wise Data")} > <GrDocumentPdf /> </Button>
                            </div>
                        </div>

                        {/* TABLE */}
                        <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
                            <table id="my-table4" style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }} >
                                <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                                    <tr>
                                        <th style={{ backgroundColor: "#4f7f5f", color: "white", textAlign: "left", width: "45%" }}> Sectors </th>
                                        <th style={{ backgroundColor: "#4f7f5f", color: "white", textAlign: "right", width: "15%" }}> Mandal </th>
                                        <th style={{ backgroundColor: "#4f7f5f", color: "white", textAlign: "right", width: "20%" }}> Score </th>
                                        <th style={{ backgroundColor: "#4f7f5f", color: "white", textAlign: "right", width: "20%" }}> Grade </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredIndicatorData.map((item, i) => (
                                        <tr key={i} style={{ backgroundColor: i % 2 === 0 ? "#f9f9f9" : "#ffffff", borderBottom: "1px solid #eee" }} >
                                            <td style={{ textAlign: "left" }} > {item.sectors} </td> <td style={{ textAlign: "right" }} > {item.mandal} </td>
                                            <td style={{ textAlign: "right" }} > {item.averagescore} </td> <td style={{ textAlign: "center" }} > {item.grade} </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>) : (<div style={{ textAlign: "center", padding: "20px" }}> Mandal Level Indicators are Not Available </div>)}
            </Modal.Body>

            {/* FOOTER */}
            <Modal.Footer className="justify-content-end">
                <Button variant="danger" onClick={() => { setSearchText(""); setShowModal(false); }} style={{ padding: "8px 25px", borderRadius: "25px" }} > Close </Button>
            </Modal.Footer>
        </Modal>

        <Modal
            show={showModal1}
            onHide={() => { setSearchText1(""); setShowModal1(false); }}
            centered
            dialogClassName="custom-modal-width1"
        >

            <Modal.Header
                closeButton
                style={{
                    backgroundColor: "#4f7f5f",
                    color: "white",
                    borderTopLeftRadius: "14px",
                    borderTopRightRadius: "14px"
                }}
            >
                <h4 style={{ margin: 0, fontWeight: "600" }}> Sector Wise Scores & Grades </h4>
            </Modal.Header>

            <Modal.Body style={{ padding: "20px" }}>
                {sectorData && sectorData.length > 0 ? (
                    <>
                        {/* Search + Buttons Row */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "15px",
                                flexWrap: "wrap",
                                gap: "10px"
                            }}
                        >
                            {/* Search */}
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div
                                    style={{
                                        background: "#f1f1f1",
                                        padding: "8px 12px",
                                        border: "1px solid #ccc",
                                        borderRight: "none"
                                    }}
                                >
                                    <AiOutlineSearch />
                                </div>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    value={searchText1}
                                    onChange={(e) => setSearchText1(e.target.value)}
                                    style={{
                                        padding: "8px",
                                        border: "1px solid #ccc",
                                        outline: "none",
                                        width: "250px"
                                    }}
                                />
                            </div>

                            {/* Buttons */}
                            <div>
                                <Button variant="success" size="sm" style={{ marginRight: "10px" }} onClick={() => exportToExcel("my-table5", "Sector wise Data")} > <RiFileExcel2Line /> </Button>
                                <Button variant="danger" size="sm" onClick={() => exportToPDF("my-table5", "Sector wise Data")} > <GrDocumentPdf /> </Button>
                            </div>
                        </div>

                        {/* TABLE */}
                        <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
                            <table id="my-table5" style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }} >
                                <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                                    <tr>
                                        <th style={{ backgroundColor: "#4f7f5f", color: "white", width: "45%" }}> District </th>
                                        <th style={{ backgroundColor: "#4f7f5f", color: "white", width: "15%" }}> Mandal </th>
                                        <th style={{ backgroundColor: "#4f7f5f", color: "white", width: "20%" }}> Sector </th>
                                        <th style={{ backgroundColor: "#4f7f5f", color: "white", width: "20%" }}> No.of.indicators </th>
                                        <th style={{ backgroundColor: "#4f7f5f", color: "white", width: "20%" }}> Score </th>
                                        <th style={{ backgroundColor: "#4f7f5f", color: "white", width: "20%" }}> Grade </th>
                                    </tr>
                                </thead>

                                <tbody> {filteredData.map((item, i) => (<tr key={i}>
                                    <td style={{ textAlign: "left" }}>{item.district_name}</td> <td style={{ textAlign: "left" }}>{item.mandal_name}</td> <td style={{ textAlign: "left" }}>{item.ind_broad_sector_name}</td>
                                    <td style={{ textAlign: "right" }}>{item.noofindicators}</td> <td style={{ textAlign: "right" }}>{item.averagescore}</td> <td style={{ textAlign: "center" }}>{item.grade}</td>
                                </tr>))} </tbody>
                                {filteredData?.length > 0 && <tfoot style={{ position: "sticky", bottom: "0px" }}>
                                    <tr style={{ backgroundColor: "#4f7f5f" }}> <td style={{ textAlign: "center" }} colSpan={3}> Total </td>
                                        <td style={{ textAlign: "right" }}>{filteredData?.reduce((a, v) => (a + v.noofindicators), 0).toLocaleString("en-IN")} </td>
                                        <td style={{ textAlign: "right" }} colSpan={2}> </td>  </tr> </tfoot>}
                            </table> </div> </>) : (<div style={{ textAlign: "center", padding: "20px" }}> Sector Level Indicators are Not Available </div>)}
            </Modal.Body>

            {/* FOOTER */}
            <Modal.Footer className="justify-content-end">
                <Button variant="danger" onClick={() => { setSearchText1(""); setShowModal1(false); }} style={{ padding: "8px 25px", borderRadius: "25px" }} > Close </Button>
            </Modal.Footer>
        </Modal>

    </>
    );

};

const RightTable = ({ title, rows = [], showTotal = false, role_cat_id, }) => {

    const totals = rows.reduce(
        (acc, row) => ({
            district: acc.district + Number(row[1] || 0),
            mandal: acc.mandal + Number(row[2] || 0),
            monitoring: acc.monitoring + Number(row[3] || 0),
        }),
        { district: 0, mandal: 0, monitoring: 0 }
    );

    return (
        <>
            <div style={{ marginBottom: "20px" }}>
                <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered" >

                    <thead>
                        <tr style={{ background: "#4f7f5f", color: "white" }}>
                            <th style={{ ...thStyle }}>{title}</th>
                            {(role_cat_id === "113" || role_cat_id === "119") && (<th style={thStyle}>District</th>)}
                            <th style={{ ...thStyle }}>Mandal</th>
                            <th style={{ ...thStyle }}>Monitoring at District Level</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.length > 0 ? (
                            rows.map((row, i) => (
                                <tr key={i}>
                                    {row.map((cell, j) => {

                                        // 🚫 Skip District column if role not 113 or 119
                                        if (j === 1 && !(role_cat_id === "113" || role_cat_id === "119")) { return null; }

                                        return (
                                            <td
                                                key={j}
                                                style={{
                                                    ...tdStyle,
                                                    textAlign: j === 0 ? "left" : "right",
                                                    cursor: "default",
                                                    color: "black",
                                                    fontWeight: "normal"
                                                }}
                                            >
                                                {cell}
                                            </td>
                                        );
                                    })} </tr>))) : (
                            <tr>
                                <td colSpan={role_cat_id === "113" || role_cat_id === "119" ? 4 : 3}
                                    style={{ textAlign: "center", padding: "12px", color: "red" }} > No Details Available </td>
                            </tr>)} </tbody>

                    {showTotal && rows.length > 0 && (<tfoot>
                        <tr style={{ backgroundColor: "#4f7f5f", color: "white", fontWeight: "600" }}> <td style={tdStyle}>Total</td>
                            {(role_cat_id === "113" || role_cat_id === "119") && (<td style={{ ...tdStyle, textAlign: "right" }}> {totals.district} </td>)}
                            <td style={{ ...tdStyle, textAlign: "right" }}> {totals.mandal} </td> <td style={{ ...tdStyle, textAlign: "right" }}> {totals.monitoring} </td> </tr> </tfoot>)} </table> </div > </>);
};


const thStyle = {
    border: "1px solid #dcdcdc",
    padding: "6px",
    textAlign: "center",
    background: "#4f7f5f",
    color: "white",
    fontSize: "13px"
};

const tdStyle = {
    border: "1px solid #eee",
    padding: "5px",
    textAlign: "center",
    fontSize: "13px"
};



export default ScoreCards;
